import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Flex, Layout, Menu, Spin } from 'antd';
import type { MenuProps } from 'antd';
import globalStore from 'ts/store/Global';
import styles from '../styles/styles.module.scss';
import ContributorsSubHeader from 'ts/pages/ContributorsList/components/ContributorsSubHeader';
import CommitStat from './CommitStat';
import { observer } from 'mobx-react-lite';

const { Sider, Content } = Layout;

const GitStatLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const current = location.pathname.split('/').pop() || 'contributors';

  const menuItems: MenuProps['items'] = [
    {
      key: 'list',
      label: 'Contributors',
    },
    {
      key: 'by-user',
      label: 'By User',
    },
  ];

  const renderContent = () => {
    switch (current) {
      case 'list':
        return <ContributorsSubHeader />;
      case 'by-user':
        return <CommitStat />;
      default:
        return <h1>{current} Content will be here</h1>;
    }
  };

  if (globalStore.userData.name === '') {
    return (
      <Flex
        style={{
          width: '100%',
          height: '60vh',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin tip="Loading user data" size="large">
          {
            <div
              style={{
                padding: 100,
                borderRadius: 4,
              }}
            />
          }
        </Spin>
      </Flex>
    );
  }

  return (
    <Layout className={styles.gitStatLayout}>
      <Layout className={styles.gitStatSiderWrap}>
        <Sider className={styles.gitStatSider}>
          <Menu
            mode="inline"
            className={styles.gitStatMenu}
            selectedKeys={[current]}
            items={menuItems}
            onClick={(e) => navigate(`/contributors/${e.key}`)}
          />
        </Sider>
        <Layout className={styles.gitStatContentWrap}>
          <Content className={styles.gitStatContent}>{renderContent()}</Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default observer(GitStatLayout);
